import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';
import { Translatable } from '@app/types/translatable.type';
import { WorkSchedule } from '@models/time-off-v3/works-schedule.model';

export class NameColumn extends BadgeColumn<WorkSchedule> {
    title = 'time-off-v3.name';
    property = 'name';
    type: CellDisplay = CellDisplay.badge;

    getBadgeDisplay(workSchedule: WorkSchedule): BadgeDisplay | undefined {
        if (!workSchedule.isDefault) {
            return;
        }

        return {
            type: 'default',
            label: 'time-off-v3.default',
        };
    }

    getCellText(workSchedule: WorkSchedule): Translatable {
        return workSchedule.name;
    }
}
